<template>
    <div class="weui-cells weui-cells_form">
      <h3 class="page__title">订单列表检索</h3>
      
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">状态</label>
          </div>
          <div class="weui-cell__bd" @click="pickState" >
              <a style="align-text:left;color: #238E23;">{{orderState.label}}</a>
          </div>
      </div>         
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">商品类型</label>
          </div>
          <div class="weui-cell__bd" @click="pickProduct" >
              <a style="align-text:left;color: #238E23;">{{productSelected.label}}</a>
          </div>
      </div>            
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">OPENID</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="精确匹配，必需完整输入" v-model="userAccount" />
          </div>
      </div>          
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">数量</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="" v-model="num" />
          </div>
      </div>   
                 
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">紧凑模式</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
            <label for="switchCP" class="weui-switch-cp">
                  <input id="switchCP" class="weui-switch-cp__input" type="checkbox" checked="checked" v-model="isTable"/>
                  <div class="weui-switch-cp__box"></div>
              </label>
          </div>
      </div>    
   
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
          </div>
          <div class="weui-cell__bd">
            <a @click="getOrderList" class="weui-btn weui-btn_primary">检索</a>
          </div>
      </div>          
      <div class="weui-msg" v-if="orderList.length > 0">
        <div v-if="isTable">
          <table class="table table-striped " style="font-size: small;" >
            <thead>
               <td>商品</td>
               <td>状态</td>
               <td>备注</td>
            </thead>
            <tbody>
              <tr v-for="order in orderList" :key="order.order_id" 
                v-show="(order.product_type == productSelected.value) || ( productSelected.value == 0)">
                                       
                <td>{{order.product_name}}</td>
                <td>{{getStateName(order.state)}}</td>  
                <td>
                  微信{{order.amount/100.00}} + 余额{{order.balance/100.00}} + 链点{{order.point/100.00}} = ￥{{(order.amount +order.balance + order.point)/100.00}} <br/>
                  订单号 {{order.order_id}} <br/>
                  客户ID <a  @click="toUrl(order.user_account)" style="color:blue">{{order.user_account}}</a> 
                </td>
                              
                <!-- 
                  <td>{{order.product_type}}</td>  
                  <td>{{order.refund_amount/100.00}}</td>
                  <td>{{order.create_time}}</td>
                  <td>{{order.server_time}}</td>
                  <td>{{order.modify_time}}</td>
                  <td  @click="toUrl(order.user_account)">{{order.user_account}}</td> 
                  <td>{{order.mobile}}</td> 
                  <td>{{order.plate}}</td> 
                  <td>{{order.nickname}}</td>
                  <td>{{order.pos_id}}</td>
                  <td>{{order.pos_name}}</td>
                  <td>
                    <input  type="text" placeholder="如果确认退款，请输入YES" v-model="confirm_refund">
                    <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="refund(order.order_id)">退款</a>
                  </td>
                -->
              </tr>
            </tbody>
            <tfoot>

            </tfoot>
          </table>  
        </div>
        <div v-else>
        <div class="weui-form-preview" v-for="order in orderList" :key="order.order_id"
        v-show="(order.product_type == productSelected.value) || ( productSelected.value == 0)">
            <div class="weui-form-preview__hd">
                <label class="weui-form-preview__label">订单号</label>
                <em class="weui-form-preview__value">{{order.order_id}}</em>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">状态</label>
                    <span class="weui-form-preview__value">{{getStateName(order.state)}}</span>
                </div>
              
              <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">产品ID</label>
                    <span class="weui-form-preview__value">{{order.product_type}}</span>
                </div>
              <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">产品名称</label>
                    <span class="weui-form-preview__value">{{order.product_name}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">支付方式</label>
                    <span class="weui-form-preview__value">微信{{order.amount/100.00}} + 余额{{order.balance/100.00}} + 链点{{order.point/100.00}} = ￥{{(order.amount +order.balance + order.point)/100.00}}</span>
                </div>
                
                <div class="weui-form-preview__item" v-show="order.state == 4">
                    <label class="weui-form-preview__label">退款金额</label>
                    <span class="weui-form-preview__value">{{order.refund_amount/100.00}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">创建时间</label>
                    <span class="weui-form-preview__value">{{order.create_time}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">服务时间</label>
                    <span class="weui-form-preview__value"> {{order.server_time}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">最后修改</label>
                    <span class="weui-form-preview__value">{{order.modify_time}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户ID</label>
                    <span class="weui-form-preview__value a_hot_touch" @click="toUrl(order.user_account)">{{order.user_account}}</span> 
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户手机</label>
                    <span class="weui-form-preview__value">{{order.mobile}} </span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户车牌</label>
                    <span class="weui-form-preview__value"> {{order.plate}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户昵称</label>
                    <span class="weui-form-preview__value">{{order.nickname}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">网点ID</label>
                    <span class="weui-form-preview__value"> {{order.pos_id}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">网点名称</label>
                    <span class="weui-form-preview__value">{{order.pos_name}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">备注</label>
                    
                    <span class="weui-form-preview__value" v-if="order.state == 3" >{{order.remark}}</span>
                    <span class="weui-form-preview__value" v-else-if="order.state == 2" >未服务订单超过30分钟，会自动退款</span>
                    <span class="weui-form-preview__value" v-else-if="order.state == 1" >未支付订单，无需做任何操作；如果使用了链点，链点将会在30分钟后退返</span>
                    <span class="weui-form-preview__value" v-else-if="order.state == 4" >已经退款的订单，无需做任何操作</span>
                </div>
            </div>
            <div class="weui-form-preview__ft" v-if="order.state == 3 || order.state == 2">
              <input  type="text" placeholder="如果确认退款，请输入YES" v-model="confirm_refund">
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="refund(order.order_id)">退款</a>
            </div>
            <div class="weui-form-preview__ft" v-else-if="order.state == 4  && order.refund_amount < order.amount">
              <input  type="text" placeholder="如果确认再次退款，请输入YES" v-model="confirm_refund">
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="refund(order.order_id)">再次退款</a>
            </div>
        </div>
        </div>
      </div>      
      <div id="loadingToast" style="display: none;" v-else-if="ing">
          <div class="weui-mask_transparent"></div>
          <div class="weui-toast">
              <span class="weui-primary-loading weui-primary-loading_transparent weui-icon_toast">
                <span class="weui-primary-loading__dot"></span>
              </span>
              <p class="weui-toast__content">加载中</p>
          </div>
      </div>
      <div class="weui-msg" v-else>
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">没有符合条件的订单</h2>
            <p class="weui-msg__desc">可修改检索条件，再次试试</p>
        </div>
      </div>
      <div role="alert" class="weui-toptips weui-toptips_warn" id="warnToast">{{this.errMsg}}</div>
    </div>
  </template>

  <style>
.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>

<script>

import axios from "axios"
import JQ from 'jquery'
import jsonp from 'jsonp'

function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }
export default {
  data () {
    return {
      isTable:false,
      ing:true,
      confirm_refund:"",
      errMsg:"获取数据失败",
      userAccount:"",
      orderid:"",
      hexiaoorderid:null,
      partnerid:"",
      dateStr : new Date().Format("yyyy-MM-dd") ,
      num:100,
      
      productSelected:{
            label: '所有',
            value: 0
        },
      productList: [{
            label: '所有',
            value: 0
        },{
            label: '充值',
            value: 999
        },{
            label: '购买链点',
            value: 99
        },{
            label: '快洗',
            value: 4
        },{
            label: '精洗',
            value: 2
        },{
            label: '超洗',
            value: 1
        }],
      orderState:{
            label: '所有',
            value: 0
        },
        ing:true,
      posSelected:{label: '所有',
            value: 0},
      date:new Date(),
      orderList : [],
      posList: [{
            label: '所有',
            value: 0
        }],
      stateList: [{
            label: '所有',
            value: 0
        }, {
            label: '已服务',
            value: 3
        }, {
            label: '已退款',
            value: 4
        }, {
            label: '待服务',
            value: 2
        },{
            label: '未支付',
            value: 1
        }]
    }
  },
  mounted() {
       this.partnerid = sessionStorage.getItem("partnerid")
       console.log( this.partnerid,sessionStorage.getItem("partnerid"))
       
       if(this.$route.params.userAccount) this.userAccount = this.$route.params.userAccount;
       

       this.getOrderList();

  },
  methods: {      
   toUrl(openid){
      this.$router.push({name:"userlist",params:{
        userAccount:openid
      }});
    },
    refund(tid){

      
      if((tid==null) || (tid.length<10) || (this.confirm_refund != "YES")){
        this.errMsg = ("确认要对订单"+tid+"退款，请输入YES。");
        this.showError();
        return;
      }else{

        // http://zmxcl.my-soft.net.cn/customer/omc/refund?orderId=1666088078209_2 
        let url = "/customer/omc/refund?orderId="+tid;

        console.log(url);

        /*

        jsonp(url,null,(err,data)=>{
            if(err){
              console.log(err)
            }else{
              console.log(data)
            }

          }) //*/

          let that = this;
          this.ing=true;
          axios.get(url).then(res  =>  {
            console.log(res.data)  
            this.ing =false;


            console.log(res.data)
            if((res.data == null)) {
              that.errMsg = "系统繁忙，请稍后再试";
              that.showError();return;
            }else {
              that.errMsg = res.data.retmsg;
              that.showError();
            }
          });
        
        this.getOrderList()
      }
    },
    getStateName(sid){
      let sName = sid;
      switch(sid){
        case 1: sName = "未支付";break;
        case 2: sName = "待服务";break;
        case 3: sName = "已服务";break;
        case 4: sName = "已退款";break;
      }
      return sName;
    },
    initPosList(pid){
       let pelist = JSON.parse(sessionStorage.getItem("posListOf_"+pid));

       console.log(pelist,pid)
       
       pelist.forEach(item => {
        let tmp={};
        tmp.label = item.name;
        tmp.value = item.posId;

        this.posList.push(tmp);
       });

       /*
       this.posList.push({
            label: '所有',
            value: 0
        });*/
       
    },
    changeOrderId(){
      console.log(this.orderid)
    },
    pickProduct() {
      let that = this;
      this.$weui.picker(this.productList, {
            onChange: function (result) {
                console.log(result);
                that.productSelected = result[0]
            },
            onConfirm: function (result) {
                console.log(result);
            },
            title: '选择订单相关产品'
        });
    },
    pickState() {
      let that = this;
      this.$weui.picker(this.stateList, {
            onChange: function (result) {
                console.log(result);
                that.orderState = result[0]
            },
            onConfirm: function (result) {
                console.log(result);
            },
            title: '选择订单状态'
        });
    },
    pickPos() {
      let that = this;
      this.$weui.picker(this.posList, {
            onChange: function (result) {
                console.log(result);
                that.posSelected = result[0]
            },
            onConfirm: function (result) {
                console.log(result);
            },
            title: '选择网点'
        });
    },
    pickerDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
            onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
                that.dateStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                that.date = new Date(result[0].value,result[1].value,result[2].value)
            },
            onConfirm: function (result) {
                console.log(result);
                //that.getReport(that.dateStr);
            },
            title: '请选择日期'
        });
    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 5000);
    },
    getOrderList() {
      console.log("getOrderList")
      
      this.orderList=[];

      let paras = {};

      if(this.partnerid == "M2022060601")
        paras.partnerid = null;
      else
        paras.partnerid = this.partnerid;
      paras.openid = this.userAccount;
      paras.state=this.orderState.value;
      paras.num=this.num;

      let that = this;
      axios.get('/zmomc/getOrderListByOpenid', {
        params: paras
      })
      .then(function (response) {
        console.log(response);
        that.orderList = response.data

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        console.log("always exec")
        console.log(that.orderList );
      });  
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/orderlist_user.vue